<input pInputText type="text" name="voucherCode" [disabled]="mode !== DetailMode.EDITION"
       [ngModel]="voucherCode" (ngModelChange)="voucherCodeChange.emit($event)"
       [required]="required" [minlength]="voucherMinLength"
       class="acted-highlight-req metadata-field" [tabindex]="tabindex"/>
<app-error fieldName="voucherCode" errorType="minlength" i18n="@@common-too_short_field_value">This field content should be at least {{ voucherMinLength }} characters long.</app-error>
